export const DOCUMENT_TYPE = {
  invoice: { value: 'invoice', label: 'Hóa đơn' },
  list_expense: { value: 'list_expense', label: 'Bảng kê' },
  claim_form: { value: 'claim_form', label: 'Giấy yêu cầu bồi thường' },
  hospital_discharge_paper: { value: 'hospital_discharge_paper', label: 'Giấy ra viện' },
  id_doc: { value: 'id_doc', label: 'Giấy tờ tùy thân (căn cước, hộ chiếu, giấy phép lái xe, ...)' },
  prescription: { value: 'prescription', label: 'Đơn thuốc' },
  guarantee_confirmation: { value: 'guarantee_confirmation', label: 'Giấy xác nhận bảo lãnh' },
  medical_examination: { value: 'medical_examination', label: 'Phiếu khám' },
  surgical_certificate: { value: 'surgical_certificate', label: 'Giấy chứng nhận phẫu thuật' },
  discharge_report: { value: 'discharge_report', label: 'Báo cáo ra viện' },
  medical_report: { value: 'medical_report', label: 'Báo cáo y tế' },
  specify_vote: { value: 'specify_vote', label: 'Phiếu chỉ định' },
  test_results: { value: 'test_results', label: 'Phiếu kết quả' },
  accident_report: { value: 'accident_report', label: 'Tường trình tai nạn' },
  bill: { value: 'bill', label: 'Biên lai' },
  receipts: { value: 'receipts', label: 'Phiếu thu' },
  health_records: { value: 'health_records', label: 'Sổ khám bệnh' },
  death_certificate: { value: 'death_certificate', label: 'Giấy chứng tử' },
  medical_record_summary: { value: 'medical_record_summary', label: 'Tóm tắt bệnh án' },
  dental_treatment: { value: 'dental_treatment', label: 'Phiếu khám, điều trị răng' },
  hospital_transfer_letter: { value: 'hospital_transfer_letter', label: 'Giấy chuyển tuyến khám bệnh, chữa bệnh' },
  birth_certificate: { value: 'birth_certificate', label: 'Giấy khai sinh' },
  birth_authentication: { value: 'birth_authentication', label: 'Giấy chứng sinh' },
  birth_extract: { value: 'birth_extract', label: 'Trích lục khai sinh' },
  treatment_confirmation: { value: 'treatment_confirmation', label: 'Giấy xác nhận' }
};

export const OPTION_NOITRU = {
  list_expense: { value: 'list_expense', label: 'Bảng kê chi tiết (nếu có)'},
  specify_vote: { value: 'specify_vote', label: 'Phiếu chi định (nếu có)'},
  surgical_certificate: { value: 'surgical_certificate', label: 'Giấy chứng nhận phẫu thuật (nếu có)'},
}

export const OPTION_NGOAITRU = {
  list_expense: { value: 'list_expense', label: 'Bảng kê chi tiết (nếu có)'},
  test: { value: 'test', label: 'Kết quả xét nghiệm (nếu có)'}
}